module.exports = __webpack_public_path__ + "media/app/assets/specializations/paladin/holy-e62f07e026936f2c7c017183b2ac2989.png";